/* eslint-disable */
import cls from '../styles/StaticContent.module.scss'
import { HeaderBar } from '@/components/HeaderBar'
import { SEO } from '@/components/SEO'
import { Footer } from '@/components/Footer'

const Privacy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy - My Reminders for Microsoft Teams"
        description="Learn how we collect, use, and protect your data in the My Reminders for Microsoft Teams application."
        keywords="privacy policy, data protection, GDPR compliance, Microsoft Teams app privacy"
      />
      <HeaderBar showLogOutButton={false} />
      <div className={cls.container}>
        <h1>TeamsReminder - Privacy Policy</h1>
        <h4>We take your privacy seriously</h4>
        <h6>Effective June 23, 2022</h6>
        <hr />
        <h2>Summary</h2>
        <blockquote>
          We respect your privacy and take data collection seriously. We will not disclose
          your emails or private information to third parties for private gains. We will
          do what we can to protect your data. We are in the business of providing
          services and our goal is to build a trusting relationship. We collect basic
          identification in order to differentiate each user from one another, and
          information about a user's teammates, so that we can streamline the process of
          scheduling reminders associated with a teammate. We also collect basic,
          aggregate usage data that is needed to improve our products for you and future
          customers. We will promptly, permanently remove any information that you no
          longer want shared upon request.
        </blockquote>
        <h2>Privacy Policy</h2>
        Appfluence values your right to control what information you do or do not want
        others to see. There is a trade-off between making it easy to find new groups,
        events, and friends, and making information available to unwanted individuals or
        corporations. Appfluence recognizes that people have their own comfort level with
        privacy, and we give users a number of controls over how much information they
        want to make public. By using Appfluence, you certify that you have read,
        understand, and agree with the provisions of our privacy policy.
        <h3>Information Appfluence Collects</h3>
        Appfluence collects the following types of information, some of which can be
        considered personal:
        <ol>
          <li>
            <b>Aggregate data</b> that is not personally identifiable for marketing and/or
            product enhancement. This may be shared with a third party.
          </li>
          <li>
            <b>Reminder content</b> that is synchronized to our servers, where it is
            stored to deliver your reminder at the right time. This information is never
            given to a third party.
          </li>
          <li>
            <b>List of channels/chats/collaborators</b>, used to facilitate the process of
            choosing the recipient for your scheduled reminders. This information is never
            given to a third party.
          </li>
          <li>
            <b>Device id, ip and email address</b>, for the purpose of differentiating
            user accounts. This information is never given to a third party.
          </li>
          <li>
            <b>Email address</b>, in order to send important notifications from the
            system, as well as invoices, training sessions and other information about or
            products. This information is never given to a third party without consent.
          </li>
        </ol>
        <h3>Data Access, Retention and Deletion</h3>
        <p>
          Users can access all their data via the application dashboard. We will promptly
          honor requests to delete all data on any user, complying as soon as possible,
          but in any case within one month since your request. Simply contact our privacy
          address listed below and we will be happy to assist.
        </p>
        <p>
          We store user data in data centers provided and managed by Microsoft Azure.
          Unless otherwise stated, all our data resides in data centers inside the United
          States. Data is secured both in transit and at rest by industry standard
          encryption algorithms. More details are available upon qualified inquiries.
        </p>
        <p>
          Appfluence retains user data for the duration of an account's active lifetime.
          User data will be deleted upon request by the account owner, or after seven (7)
          years without account activity, following sufficient notice to the user via
          email, in order to facilitate reactivation or data exporting if necessary.
        </p>
        <h3>What are your data protection rights?</h3>
        <p>
          Appfluence would like to make sure you are fully aware of all of your data
          protection rights. Every user is entitled to the following:
        </p>
        <ul>
          <li>
            <strong>The right to access</strong>: You have the right to request Appfluence
            for copies of your personal data. We may charge you a small fee for this
            service.
          </li>

          <li>
            <strong>The right to rectification</strong>: You have the right to request
            that Appfluence correct any information you believe is inaccurate. You also
            have the right to request Appfluence to complete the information you believe
            is incomplete.
          </li>

          <li>
            <strong>The right to erasure</strong> – You have the right to request that
            Appfluence erase your personal data, under certain conditions.
          </li>

          <li>
            <strong>The right to restrict processing</strong>: You have the right to
            request that Appfluence restrict the processing of your personal data, under
            certain conditions.
          </li>

          <li>
            <strong>The right to object to processing</strong>: You have the right to
            object to Appfluence's processing of your personal data, under certain
            conditions.
          </li>

          <li>
            <strong>The right to data portability</strong>: You have the right to request
            that Appfluence transfer the data that we have collected to another
            organization, or directly to you, under certain conditions.
          </li>
        </ul>
        <h3>Opinion Sharing</h3>
        By emailing us, you allow us to share any positive reviews, comments, and
        enthusiasm to others.
        <h3>Eligibility</h3>
        Appfluence does not knowingly solicit or collect information from children under
        the age of 16. If you are under the age of 16, do not register with TeamsReminder,
        or any other Appfluence product. If we learn that a user has registered in
        violation of this policy and we have collected information for a child under 16,
        or if we learn that a user between the age of 16 and 18 has registered without
        parental consent, we will delete this information as quickly as possible.
        <h3>Changes to Policy</h3>
        In the event that Appfluence changes its privacy policy, we will notify our users
        by asking them to sign the User Agreement again, by email, or via the app itself.
        <h3>Missing Information</h3>
        If we have inadvertently failed to address certain privacy policies, please notify
        us and we will resolve it as soon as possible.
        <h3>Questions about Privacy</h3>
        <p>
          If you have questions about our privacy policy, contact us at&nbsp;
          <a href="mailto:support+privacy@appfluence.com?subject=About TeamsReminder privacy">
            support+privacy@appfluence.com
          </a>
          . We are fully <a href="https://appfluence.com/gdpr">GDPR compliant</a> and
          offer a series of self-serve mechanisms for users to access their data. Our Data
          Protection Officer is Pablo Diaz-Gutierrez. Written inquiries can be sent to:
        </p>
        Appfluence Inc
        <br />
        PO Box 8795
        <br />
        Emeryville CA 94662
        <br />
        USA
        <br />
      </div>
      <Footer />
    </>
  )
}

export default Privacy
